module.exports = __webpack_public_path__ + "assets/img/back.f670ea1a.png";